var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.schema.classes},_vm._l((_vm.schema.content),function(sc){return _c('span',{key:sc.name},[_c('t-widget',{attrs:{"schema":sc,"data":_vm.data},on:{"input":_vm.simpleEmit}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }